var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgDocumentShared = function SvgDocumentShared(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.009 3.999c0-1.104.884-2.001 1.992-2.001H14l6.001 6V20a2.001 2.001 0 0 1-2.002 1.998H5.99A1.993 1.993 0 0 1 4 20l.01-16.001Zm14.492 5-5.503-5.503v5.503h5.504Zm-2.9 8.572c0-.452-.138-.846-.372-1.187-.205-.3 2.771-.145 2.771 1.187V18a1 1 0 0 1-1 1h-.4a1 1 0 0 1-1-1v-.429Zm-9.6 0c0-1.332 2.799-2 4.2-2 1.399 0 4.2.668 4.2 2V18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-.429Zm5.993-4.857c0 .947-.8 1.715-1.794 1.715s-1.8-.768-1.8-1.715c0-.946.806-1.714 1.8-1.714s1.794.768 1.794 1.714Zm4.207 1.716c0 .63-.535 1.142-1.198 1.142-.664 0-1.202-.512-1.202-1.142 0-.631.538-1.143 1.202-1.143.663 0 1.198.512 1.198 1.143Z",
    fill: "#000"
  })));
};

export default SvgDocumentShared;